import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import _ from 'lodash';

type Props = {
  onChange: (onboardingFlowId: string | undefined) => void;
  value: string | undefined;
  className?: string;
  disabled?: boolean;
};

const SelectOnboardingFlow = ({ onChange, value, className, ...props }: Props) => {
  const fetchOnboardingFlows = async () => {
    try {
      const onboardingFlows = await apiFetch(
        null,
        'corp-api/onboarding-control-panel/publishedFlows',
        {
          method: 'GET',
        },
      );
      const options = onboardingFlows.map((of: Record<string, any>) => ({
        label: of.name,
        value: of._id,
      }));

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  };

  return (
    <Select
      className={className}
      onChange={(selectedOption: SelectOption | null) => {
        onChange(selectedOption?.value);
      }}
      value={value}
      defaultOptions
      cacheOptions
      loadOptions={_.throttle(fetchOnboardingFlows, 500)}
      placeholder="Select onboarding flow"
      {...props}
    />
  );
};

export default SelectOnboardingFlow;
